import styled, { css } from "styled-components"
import { CursorCircleWhite } from "shared/Styles/Cursors"

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 130px;
  margin-bottom: 100px;
  ${CursorCircleWhite}
  &.timeline {
    padding-top: 30px;
    margin-bottom: 50px;
  }

`

export const Title = styled.h1`
  position: relative;
  margin: 0;
  font-weight: 800;
  font-size: 65px;
  line-height: 1.94;
  z-index: 2;
  color: #fff;
  font-family: "sharp_grotesksemibold_25", sans-serif;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    width: 100%;
    height: 1px;
    background-color: pink;
    z-index: -1;
  }
  @media screen and (max-width: 767px) {
    font-size: 45px;
  }
  @media screen and (max-width: 576px) {
    font-size: 35px;
  }
  @media screen and (max-width: 420px) {
    font-size: 30px;
  }
`
export const SmallText = styled.h2`
  position: relative;
  font-family: "sharp_groteskmedium_20";
  text-transform: uppercase;
  color: #fff;
  font-size: 8px;
  letter-spacing: 15px;
  z-index: 3;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: -120px;
    transform: translateY(-50%);
    width: 95px;
    height: 1px;
    background-color: #fff;
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 95px;
    height: 1px;
    background-color: #fff;
  }
  @media screen and (max-width: 767px) {
    &::before,
    &::after {
      width: 70px;
    }
    &::before {
      left: -90px;
    }
  }
  @media screen and (max-width: 576px) {
    &::before,
    &::after {
      width: 50px;
    }
    &::before {
      left: -60px;
    }
  }
  ${({ contact }) =>
    contact &&
    css`
      text-align: center;
      letter-spacing: 3px;
      text-transform: unset;
      color: #898989;
      font-size: 16px;
      margin-bottom: 60px;
      &::before {
        left: 120px;
      }
      &::after {
        right: 120px;
      }
      @media screen and (max-width: 767px) {
        &::before,
        &::after {
          width: 70px;
        }
        &::before {
          left: 50px;
        }
        &::after {
          right: 50px;
        }
      }
      @media screen and (max-width: 576px) {
        &::before,
        &::after {
          width: 50px;
        }
        &::before {
          left: 30px;
        }
        &::after {
          right: 30px;
        }
      }
    `}
`
